module.exports = __webpack_public_path__ + "img/plus-black.63a03470.svg";